import { Component } from "@angular/core";

@Component({
    selector: "wk-icon-user2-sprite-pds3",
    templateUrl: "./index.html",
    host: { class: "cg3-host-wk-icon-user2-sprite" },
})
export class WkIconUser2SpritePds3 {}
